import { render, staticRenderFns } from "./lbs_page.vue?vue&type=template&id=3e190c6d&scoped=true"
import script from "./lbs_page.vue?vue&type=script&lang=js"
export * from "./lbs_page.vue?vue&type=script&lang=js"
import style0 from "./lbs_page.vue?vue&type=style&index=0&id=3e190c6d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e190c6d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e190c6d')) {
      api.createRecord('3e190c6d', component.options)
    } else {
      api.reload('3e190c6d', component.options)
    }
    module.hot.accept("./lbs_page.vue?vue&type=template&id=3e190c6d&scoped=true", function () {
      api.rerender('3e190c6d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sys/lbs_page.vue"
export default component.exports